import * as types from '../dashboardActionTypes';

export default function deviceGroupsIsLoadingReducer(state = true, action) {
    switch(action.type) {
        case types.LOAD_DEVICE_GROUPS:
            return true;
        case types.LOAD_DEVICE_GROUPS_FAILED:
        case types.LOAD_DEVICE_GROUPS_SUCCESS:
            return false;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/dashboard/reducers/deviceGroupsIsLoadingReducer.js